import PageHeader from './page-header.vue';
export default PageHeader;


// WEBPACK FOOTER //
// ./src/components/page-header/index.js